/**
 * Opportunities Tab Component
 * 
 * Search and browse government procurement opportunities.
 * Extracted from OpportunitiesDashboard.tsx for use in External Data Dashboard.
 */

import React from 'react';
import { OpportunitiesDashboard } from '../../pages/OpportunitiesDashboard';

/**
 * Simple wrapper that embeds the full OpportunitiesDashboard
 * Removes the outer page header since it's now within a tab
 */
export function OpportunitiesTab() {
  return (
    <div className="opportunities-tab-wrapper">
      <OpportunitiesDashboard />
    </div>
  );
}

